"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
const VARIANT_STYLES = {
    default: "bg-blue-500/10 border-blue-500/20 text-blue-400",
    destructive: "bg-red-500/10 border-red-500/20 text-red-400",
};
export const Alert = forwardRef(({ variant = "default", className, ...props }, ref) => (_jsx("div", { ref: ref, className: clsx("relative w-full rounded-lg border p-4", VARIANT_STYLES[variant], className), ...props })));
Alert.displayName = "Alert";
export const AlertDescription = forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: clsx("text-sm [&_p]:leading-relaxed", className), ...props })));
AlertDescription.displayName = "AlertDescription";
